<button class="btn btn__flat {{ styleClasses }}" [disabled]="disabled" [class.uppercase]="uppercase" (click)="onSubmit()">
  <span class="icon-wrap" *ngIf="withIcon">
    <i class="icon btn-icon {{ iconClass }}"></i>
  </span>
  <span>{{ buttonLabel }}</span>
</button>
